import React from "react";
import { Box, HStack, Text, Image, CircularProgress, CircularProgressLabel } from "@chakra-ui/react";
import { ProfileImage, CallIcon, EmailIcon } from "./Icons";
import { ActionButton } from "../clients/ActionButton";

interface ProfileInfoProps {
  name: string;
  email: string;
  sopAdherence: number;
  objectionHandling: number;
  talkToListenRatio: number;
}

export function ProfileInfo({ name, email, sopAdherence, objectionHandling, talkToListenRatio }: ProfileInfoProps) {
  return (
    <Box
      as="section"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      p={6}
      bg="white"
      width="254px"
      flexShrink={0}
    >
      <Box>
        <HStack spacing={3} mb={6} align="center">
          <ProfileImage boxSize="40px" flexShrink={0} firstLetter={name.charAt(0)} />
          <Text fontSize="lg" fontWeight="500" color="gray.700" noOfLines={1}>
            {name}
          </Text>
        </HStack>
        
        <Box>
          <HStack spacing={2} mb={2}>
            <Text fontSize="sm" color="gray.500" noOfLines={1}>
              SOP Adherence:
            </Text>
            <CircularProgress 
              value={sopAdherence} 
              color={sopAdherence < 70 ? "red.500" : "green.500"}
              size="30px"
              thickness="10px"
            >
              <CircularProgressLabel fontSize="8px" fontWeight="bold">
                {sopAdherence}%
              </CircularProgressLabel>
            </CircularProgress>
          </HStack>
          <HStack spacing={2} mb={2}>
            <Text fontSize="sm" color="gray.500" noOfLines={1}>
              Objection Handling:
            </Text>
            <Box 
              px={2} 
              py={1} 
              borderRadius="sm" 
              bg={objectionHandling < 60 ? "red.50" : "green.50"} 
              color={objectionHandling < 60 ? "red.700" : "green.700"}
              fontSize="xs"
              fontWeight="semibold"
            >
              {objectionHandling}
            </Box>
          </HStack>
          <HStack spacing={2}>
            <Text fontSize="sm" color="gray.500" noOfLines={1}>
              Talk to Listen:
            </Text>
            <CircularProgress 
              value={talkToListenRatio} 
              color={talkToListenRatio > 70 ? "orange.500" : "blue.500"}
              size="30px"
              thickness="10px"
            >
              <CircularProgressLabel fontSize="8px" fontWeight="bold">
                {talkToListenRatio}%
              </CircularProgressLabel>
            </CircularProgress>
          </HStack>
        </Box>
      </Box>
      
      <HStack spacing={1} mt={6}>
        {/* <ActionButton
          text="Call"
          iconUrl="https://cdn.builder.io/api/v1/image/assets/TEMP/5e83e3a08b55379af9be528ec70f3134dee97990?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
        /> */}
        <ActionButton
          text="Email"
          onClick={() => {
            window.open(`mailto:${email}`, '_blank');
          }}
          iconUrl="https://cdn.builder.io/api/v1/image/assets/TEMP/bc85146c2f414bdc91ac81795bbbc5762a23046e?placeholderIfAbsent=true&apiKey=9181b4b5be8946e9a117f76f8f1082b9"
        />
      </HStack>
    </Box>
  );
} 